import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'actionDate',
    standalone: true
})
export class ActionDatePipe implements PipeTransform {

  transform(value: string, type: ActionDateType = ActionDateType.DATE_ONLY): string {
    let date = new Date(value);
    if (date.toString() === 'Invalid Date') date = new Date();

    const options: Intl.DateTimeFormatOptions = type === ActionDateType.DATE_ONLY
      ? { year: 'numeric', month: 'numeric', day: 'numeric' }
      : { dateStyle: 'short', hour12: true, timeStyle: 'short' };

    return new Intl.DateTimeFormat('en-US', options).format(date);
  }

}

export enum ActionDateType {
  DATE_ONLY = 'DATE_ONLY',
  DATE_TIME = 'DATE_TIME'
}
